import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { Table, TableCell, TableRow } from '@mui/material';

import { RowArticleMobile } from './row-article-mobile';
import { SupplierTableBody } from '../../../../components/supplier-table/supplier-table-body';
import { SupplierTableHead } from '../../../../components/supplier-table/supplier-table-head';
import { WishListSupplier } from '../../../../models/wish-list';

export interface SupplierTableProps {
    supplier: WishListSupplier;
}

export const SupplierTableMobile = (props: SupplierTableProps): ReactElement => {
    const { supplier } = props;

    return (
        <Table>
            <SupplierTableHead>
                <TableRow>
                    <TableCell>
                        <PoolTypography typography="subtitle1">
                            <strong>{supplier?.name}</strong>
                        </PoolTypography>
                    </TableCell>
                </TableRow>
            </SupplierTableHead>
            <SupplierTableBody>
                {supplier.items.map(item => (
                    <RowArticleMobile
                        key={item.product.id}
                        cartItem={item}
                        previewImage={item.previewImage?.['200x200'] ?? supplier.image?.['200x200']}
                    />
                ))}
            </SupplierTableBody>
        </Table>
    );
};
